const ID_CUOTA_GAS = 110; //CUOTA GESTOR TECNICO DEL SISTEMA
const ID_CUOTA_ELEC_EXTRA = 10; // EXTRAPENINSULARES
const ID_CUOTA_ELEC_OS = 20; //OPERADOR SISTEMA
const ID_CUOTA_ELEC_OM = 30; //OPERADOR MERCADO
const ID_CUOTA_ELEC_INTER = 80; //COSTE COMP. INTERRUMPIBILIDAD
const ID_CUOTA_ELEC_RECARGO = 85; //RECARGO RECUP. DEFICIT INGRESOS AÑO 2005
const ID_CUOTA_ELEC_MORA = 90; //MORATORIA NUCLEAR

const FECHA_INICIO_ELEC = '2009/01/01';

const TIPO_DECLARACION_CUOTA = 'C'; //Cuota
const FORMA_DE_PAGO = 'C'; // Cuenta
const BASECOTIZACION_CUOTAS = {
  TARIFA: 1, //Tarifa - elec
  PEAJE: 2, // Peaje -elec
  GAS: 4, // Gas natural
  PEAJES: 7 // Gas peajes y canones
};

// Información periodos facturación en cuotas
const PERIODO_CUOTA_INIT = {
  id: '',
  idCuota: ID_CUOTA_GAS,
  idBaseCo: null,
  periodoConsumo: null,
  facturacion: 0,
  nukwhfac: 0,
  baseImponible: 0,
  tipo: 0,
  cuotaTributaria: 0
};

// Modelo periodo en Cuota Electrica 1-Periodo -  Cuotas se transformarar en PERIODO_CUOTA_INIT
const PERIODO_CUOTA_ELEC_INIT = {
  id: '',
  cuotas: [],
  idBaseCo: null,
  periodoConsumo: null,
  facturacion: 0,
  nukwhfac: 0,
  baseImponible: 0
};

// modelo Cuota
const CUOTAS_ELEC_INIT = {
  id: null,
  tipo: null,
  cuotaTributaria: null
};

export {
  ID_CUOTA_GAS,
  ID_CUOTA_ELEC_EXTRA,
  ID_CUOTA_ELEC_OS,
  ID_CUOTA_ELEC_OM,
  ID_CUOTA_ELEC_INTER,
  ID_CUOTA_ELEC_RECARGO,
  ID_CUOTA_ELEC_MORA,
  FECHA_INICIO_ELEC,
  BASECOTIZACION_CUOTAS,
  PERIODO_CUOTA_INIT,
  PERIODO_CUOTA_ELEC_INIT,
  CUOTAS_ELEC_INIT,
  TIPO_DECLARACION_CUOTA,
  FORMA_DE_PAGO
};
